
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("simdds/app", function(){ return i("simdds/app.ts");});
d("simdds/config/environment", function(){ return i("simdds/config/environment.js");});
d("simdds/formats", function(){ return i("simdds/formats.js");});
d("simdds/models/filters/bessel-filter", function(){ return i("simdds/models/filters/bessel-filter.ts");});
d("simdds/models/filters/butterworth-filter", function(){ return i("simdds/models/filters/butterworth-filter.ts");});
d("simdds/models/filters/chebyshev-filter", function(){ return i("simdds/models/filters/chebyshev-filter.ts");});
d("simdds/models/filters/inverse-chebyshev-filter", function(){ return i("simdds/models/filters/inverse-chebyshev-filter.ts");});
d("simdds/models/graphs/spur-graph", function(){ return i("simdds/models/graphs/spur-graph.ts");});
d("simdds/models/graphs/waveform-graph", function(){ return i("simdds/models/graphs/waveform-graph.ts");});
d("simdds/models/graphs/x-zoom-bound", function(){ return i("simdds/models/graphs/x-zoom-bound.ts");});
d("simdds/models/graphs/y-zoom-bound", function(){ return i("simdds/models/graphs/y-zoom-bound.ts");});
d("simdds/models/graphs/zoom", function(){ return i("simdds/models/graphs/zoom.ts");});
d("simdds/models/harmonics/harmonics-initial", function(){ return i("simdds/models/harmonics/harmonics-initial.ts");});
d("simdds/models/harmonics/harmonics-negative", function(){ return i("simdds/models/harmonics/harmonics-negative.ts");});
d("simdds/models/harmonics/harmonics-positive", function(){ return i("simdds/models/harmonics/harmonics-positive.ts");});
d("simdds/models/harmonics/harmonics", function(){ return i("simdds/models/harmonics/harmonics.ts");});
d("simdds/models/ppt-spur", function(){ return i("simdds/models/ppt-spur.ts");});
d("simdds/models/product", function(){ return i("simdds/models/product.ts");});
d("simdds/router", function(){ return i("simdds/router.ts");});
d("simdds/services/cdp", function(){ return i("simdds/services/cdp.ts");});
d("simdds/services/circuit", function(){ return i("simdds/services/circuit.ts");});
d("simdds/services/display-options", function(){ return i("simdds/services/display-options.ts");});
d("simdds/services/feedback", function(){ return i("simdds/services/feedback.ts");});
d("simdds/services/filter", function(){ return i("simdds/services/filter.ts");});
d("simdds/services/logger", function(){ return i("simdds/services/logger.ts");});
d("simdds/services/state", function(){ return i("simdds/services/state.ts");});
d("simdds/services/url", function(){ return i("simdds/services/url.ts");});
d("simdds/utils", function(){ return i("simdds/utils.ts");});
d("simdds/services/aditools-analytics", function(){ return i("simdds/services/aditools-analytics.js");});
d("simdds/services/aditools-site", function(){ return i("simdds/services/aditools-site.js");});
d("simdds/services/page-title", function(){ return i("simdds/services/page-title.js");});
d("simdds/component-managers/glimmer", function(){ return i("simdds/component-managers/glimmer.js");});
d("simdds/initializers/app-version", function(){ return i("simdds/initializers/app-version.js");});
d("simdds/services/intl", function(){ return i("simdds/services/intl.js");});
d("simdds/utils/intl/missing-message", function(){ return i("simdds/utils/intl/missing-message.js");});
d("simdds/container-debug-adapter", function(){ return i("simdds/container-debug-adapter.js");});
d("simdds/templates/index", function(){ return i("simdds/templates/index.hbs");});
d("simdds/controllers/index", function(){ return i("simdds/controllers/index.ts");});
d("simdds/routes/index", function(){ return i("simdds/routes/index.ts");});
d("simdds/templates/application", function(){ return i("simdds/templates/application.hbs");});





if (!runningTests) {
  i("../app").default.create({"name":"simdds","version":"2.13.0+79e53849"});
}

